/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Money_TodayInputs */

const en_features_money_today = /** @type {(inputs: Features_Money_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€120`)
};

const pl_features_money_today = /** @type {(inputs: Features_Money_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`450 zł`)
};

/**
* | output |
* | --- |
* | "€120" |
*
* @param {Features_Money_TodayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_money_today = /** @type {((inputs?: Features_Money_TodayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Money_TodayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_money_today(inputs)
	return en_features_money_today(inputs)
});